export default () => ({
    digits: ['', '', '', '', '', ''],

    get value() {
        return this.digits.join('');
    },

    init() {
        if (this.$root.hasAttribute('autofocus')) {
            this.$refs.digit0.focus();
        }
    },

    onInput(index, event) {
        const input = event.target;
        const value = input.value.replace(/\D/g, '');

        if (value.length > 1) {
            this.distribute(value, index);
            return;
        }

        this.digits[index] = value;
        input.value = value;

        if (value && index < 5) {
            this.$refs[`digit${index + 1}`].focus();
        }
    },

    onKeydown(index, event) {
        if (event.key === 'Backspace') {
            event.preventDefault();

            if (this.digits[index]) {
                this.digits[index] = '';
                this.$refs[`digit${index}`].value = '';
            } else if (index > 0) {
                this.digits[index - 1] = '';
                this.$refs[`digit${index - 1}`].value = '';
                this.$refs[`digit${index - 1}`].focus();
            }
        } else if (event.key === 'ArrowLeft' && index > 0) {
            this.$refs[`digit${index - 1}`].focus();
            event.preventDefault();
        } else if (event.key === 'ArrowRight' && index < 5) {
            this.$refs[`digit${index + 1}`].focus();
            event.preventDefault();
        }
    },

    onPaste(event) {
        const text = event.clipboardData.getData('text');
        const digits = text.replace(/\D/g, '');
        const index = Number(event.target.dataset.index);

        this.distribute(digits, index);
    },

    onFocus(event) {
        event.target.select();
    },

    distribute(value, startIndex) {
        const chars = value.split('');
        let lastFilledIndex = startIndex;

        chars.forEach((char, i) => {
            const targetIndex = startIndex + i;

            if (targetIndex <= 5) {
                this.digits[targetIndex] = char;
                this.$refs[`digit${targetIndex}`].value = char;
                lastFilledIndex = targetIndex;
            }
        });

        this.$refs[`digit${Math.min(lastFilledIndex, 5)}`].focus();
    },
});
